import React from 'react';
import { CheckBox, RadioButton } from "fw/forms";
import { Col, FormGroup, Row } from 'react-bootstrap';
import { SetupTab } from 'areas/shared/pages/setup';
import { CommentsGrid, AdminAppIdHeader } from 'areas/shared/components';
import * as FormManager from 'fw/forms/form/FormManager';
import * as App from 'modules/app/App';
import * as APIRoutes from 'modules/app/API';
import API from 'fw/system/API';
import { ReviewType, QueueType, CommReviewVoteStatus } from 'areas/shared/consts';
import VotesGrid from 'areas/admin/certification/commReview/votes/VotesGrid';
import CastVoteToolbar from './votes/CastVoteToolbar';
import * as Modals from 'fw/globals/Modals';
import * as Notifications from 'fw/globals/Notifications';
import { ReviewHelpers } from 'areas/shared/helpers';

class CommReview extends SetupTab {
    initialForm() {
        return {
            rowVersion: null,
            reviewComment: ''
        }
    }

    updatePostData = (form, dirty) => {
        this.setState({ form });

        if (dirty === true)
            FormManager.dirt(this._form);
    }

    privileges() {
        return {
            add: App.hasPrivilege("AdminCommReviewAccess"),
            edit: App.hasPrivilege("AdminCommReviewAccess")
        }
    }

    urls() {
        return {
            completeCertification: APIRoutes.Admin.url("/appReview/completeCertification"),
            denyCertification: APIRoutes.Admin.url("/appReview/denyCertification"),
            get: APIRoutes.Admin.url('/commReview/getCommReviewInfo'),
            castVote: APIRoutes.Admin.url("/commReview/castVote"),
            loadComments: APIRoutes.Admin.url("/appReview/getComments"),
            save: APIRoutes.Admin.url('/commReview/save')
        }
    }

    isEnabled(data) {
        return (!data.isReviewFinished && this.props.queueTypeCode === "COM") || App.hasPrivilege("AdminFullEditAccess");
    }

    loadComments = () => {
        let rq = {
            certificationId: this.state.form.certificationId,
            queueTypeCode: QueueType.COMMITTEE_REVIEW.code,
        };

        new API().get(this.urls().loadComments, rq,
            {
                success: (r) => {
                    let form = this.state.form;
                    form.comments = r.data.comments;
                    form.canCompleteReview = r.data.canCompleteReview;

                    this.setState(form);
                }
            });
    }

    getRequest(selectedId) {
        return {
            certificationKey: selectedId
        }
    }

    saveRequest() {
        return {
            certificationId: this.state.form.certificationId,
            content: this.state.reviewComment
        }
    }

    completeCertificationReviewRequest(rqEmail) {
        if (rqEmail == null)
            rqEmail = {};

        return {
            entityKey: this.props.selectedId,
            entityId: this.state.form.entityId,
            certificationId: this.state.form.certificationId,
            rowVersion: this.state.form.rowVersion,
            reviewComment: this.state.reviewComment,
            reviewTypeCode: 'CMR',
            reviewQueueTypeCode: 'COM',
            ...rqEmail
        }
    }

    castVoteReviewRequest(formParam, fastVote, voteStatus) {
        return {
            entityId: this.state.form.entityId,
            certificationId: this.state.form.certificationId,
            certificationKey: this.props.selectedId,
            voteStatus: fastVote ? voteStatus : this.state.form.voteStatus,
            rowVersion: this.state.form.rowVersion,
            fastTrack: this.state.form.fastTrack,
            commentContent: formParam && formParam.content ? formParam.content : "",
            reviewComment: this.state.reviewComment,
            fastVote: fastVote
        }
    }

    handleApproveCertification = () => {
        const me = this;
        this.beforeSave(() => {
            me.approveCertification();
        });
    }

    confirmApproveCertification = (rq) => {
        Modals.confirm("You are about to <b>approve</b> this Application, this action cannot be undone.<br /><br />"
            + "If you wish to continue with this action please select 'Yes'.<br /><br /> If you wish to cancel, please select 'No', and you will be returned to the previous screen.",
                this.handleApproveCertification
            );
    }

    confirmDenyCertification = (rq) => {
        Modals.confirm("You are about to <b>deny</b> this Application, this action cannot be undone.<br /><br />"
            + "If you wish to continue with this action please select 'Yes'.<br /><br /> If you wish to cancel, please select 'No', and you will be returned to the previous screen.",
                this.handleDenyCertification
            );
    }

    handleDenyCertification = (rq) => {
        const me = this;
        this.beforeSave(() => {
            me.denyCertification(rq);
        });
    }

    handleCastVote = (fastVote, voteStatus, formParam) => {
        const me = this;
        this.beforeSave(() => {
            me.castVote(formParam, fastVote, voteStatus);
        });

        let form = me.state.form;

        if (fastVote)
            form.voteStatus = voteStatus;

        if (formParam && formParam.comments)
            form.comments = formParam.comments;

        me.updatePostData(form, false);
    }

    handleAppReviewToolbar = (comments) => {
        this.handleUpdateComments(comments);
    }

    handleCommentsGrid = (comments) => {
        this.setState({ reviewComment: '' });
        this.handleUpdateComments(comments);
    }

    handleCommentChange = (comment) => {
        this.dirt();
        this.setState({
            reviewComment: comment
        });
    }

    handleUpdateComments(comments) {
        let form = {
            ...this.state.form,
            comments
        };
        this.updatePostData(form, false);
    }

    openEmailDialog = () => {
        let to = this.state.form.primaryContactEmail;
        let subject = "VOCS - Certification Denied";
        let message = this.state.form.requestConnectionTemplateBody;

        this.setState({
            emailDialog: true,
            emailDialogTo: to,
            emailDialogSubject: subject,
            emailDialogMessage: message
        });
    }

    closeEmailDialog = () => {
        this.setState({
            emailDialog: false
        });
    }

    approveCertification = () => {
        this.completeAllReviews(true);
    }

    denyCertification = (rqEmail) => {
        this.completeAllReviews(false, rqEmail);
    }

    completeAllReviews = (isApproved, rqEmail) => {
        // Proceed
        const me = this;
        let url = "";
        let rq = {};

        if (isApproved)
            url = this.urls().completeCertification;
        else
            url = this.urls().denyCertification;

        rq = this.completeCertificationReviewRequest(null);

        this.setState({
            saving: true
        }, function () {
            new API().post(url, rq, {
                success: (r) => {
                    let form = this.state.form;

                    form.finalApprovalDenial = false;
                    this.setState({
                        saving: false,
                        dirty: false,
                        form: { ...form, isReviewFinished: true }
                    }, () => { if (r.data.shouldUpdateComments) this.loadComments() });

                    this.afterSave(r.data.entityId);
                    this.props.onSuccess(r.message);
                    this.props.onSave(r.data.entityId);
                    FormManager.reset();
                },
                error: r => {
                    me.setState({ saving: false });
                    this.props.onError(r.error);
                }
            })
        });
    }

    pushToArray = (arr, obj) => {
        const index = arr.findIndex((e) => e.voteId === obj.voteId || e.userName === obj.userName);

        if (index === -1) {
            arr.push(obj);
        } else {
            arr[index] = obj;
        }
    }

    castVote = (formParam, fastVote, voteStatus) => {
        // Proceed
        const me = this;
        let url = "";
        let rq = {};

        url = this.urls().castVote;
        rq = this.castVoteReviewRequest(formParam, fastVote, voteStatus);

        this.setState({
            saving: true
        }, function () {
            new API().post(url, rq, {
                success: (r) => {
                    let votes = this.state.form.votes;
                    me.pushToArray(votes, r.data.commVote);

                    this.setState({
                        title: (r.data && r.data.title) || this.state.title,
                        saving: false,
                        dirty: false,
                        rowVersion: r.data.rowVersion,
                        form: {
                            ...this.state.form,
                            ...r.data,
                            votes: votes,
                            original: {
                                ...this.state.form,
                                ...r.data
                            }
                        }
                    }, () => { if (r.data.shouldUpdateComments) this.loadComments() });

                    this.afterSave(r.data.entityId);
                    this.props.onSuccess(r.message);
                    this.props.onSave(r.data.entityId);
                    FormManager.reset();
                },
                error: r => {
                    me.setState({ saving: false });
                    this.props.onError(r.error);
                }
            })
        });
    }

    ready = () => {
        if (!this.state.form.queueAssigned)
            Notifications.error("Comm Review is currently unassigned.");
        this.focusControl && this.focusControl.focus();
    }
    
    afterSave = (entityId) => {
        // Clean Add Comment textbox
        this._commentsGrid.cleanComment();
        this.setState({ reviewComment: '' });
    }

    renderButtons = () => {
        if (!this.state.form.queueAssigned)
            return null;

        return (
            <React.Fragment>
                <hr />
                {ReviewHelpers.renderFinalDenialEmailDialog(this.state, this.closeEmailDialog, this.handleDenyCertification)}
                <Row>
                    <Col md={2}>
                        {App.hasPrivilege("AdminCommReviewApprovalDenial")  && ((this.state.form.canVote) && (this.state.form.voteStatus === null || this.state.dirty === true)) ?
                            <CastVoteToolbar
                                certificationKey={this.props.selectedId}
                                comments={this.state.form.comments}
                                onSave={this.handleCastVote}
                                fastVote={true}
                                bsStyle="default"
                                voteStatus={CommReviewVoteStatus.DENY.code}
                                disableVoting={false}
                                buttonLabel="Comm Review Denial" />
                            : null}
                    </Col>
                    <Col md={2}>
                        {App.hasPrivilege("AdminCommReviewApprovalDenial")  && ((this.state.form.canVote) && (this.state.form.voteStatus === null || this.state.dirty === true)) ?
                            <CastVoteToolbar
                                certificationKey={this.props.selectedId}
                                comments={this.state.form.comments}
                                onSave={this.handleCastVote}
                                fastVote={true}
                                voteStatus={CommReviewVoteStatus.APPROVE.code}
                                disableVoting={false}
                                buttonLabel="Comm Review Approval" />
                            : null}
                    </Col>
                    <Col md={8}>
                        {ReviewHelpers.renderAdminStepToolbar(ReviewType.COMMITTEE_REVIEW.code, QueueType.COMMITTEE_REVIEW.code, this.state.form, this.props, this._ast )}
                    </Col>
                </Row>

            </React.Fragment>
        );
    }

    renderStatusCheckboxes() {
        var me = this;

        var reviewTypesList = ReviewType.REVIEW_TYPES.map(function (reviewType, index) {
            if (me.state.form.certificationSteps.includes(reviewType.code))
                return <React.Fragment key={index}>{me.renderStatusCheckbox(reviewType)}</React.Fragment>;
			else
				return null;
        });

        return (
            <Col md={9}>
                <Row>
                    {reviewTypesList}
                </Row>
            </Col>
        );
    }

    renderStatusCheckbox(reviewType) {
        const name = reviewType.systemName + "Completed";
        return (
            <Col md={4}>
                <FormGroup>
                    <CheckBox inline name={name} label={reviewType.description} disabled="true" />
                </FormGroup>
            </Col>
        );
    }

    renderCastVote() {
        if ((this.state.form.canVote) && (this.state.form.voteStatus === null || this.state.dirty === true)) {
            return (
                <React.Fragment>
                    <Col md={1}>
                        <Row>
                            <FormGroup>
                                <RadioButton name="voteStatus"
                                    option={CommReviewVoteStatus.APPROVE.code}
                                    label={CommReviewVoteStatus.APPROVE.description}
                                    disabled={this.state.form.disableVoting} />
                            </FormGroup>
                        </Row>
                        <Row>
                            <FormGroup>
                                <RadioButton name="voteStatus"
                                    option={CommReviewVoteStatus.DENY.code}
                                    label={CommReviewVoteStatus.DENY.description}
                                    disabled={this.state.form.disableVoting}
                                />
                            </FormGroup>
                        </Row>
                    </Col>
                    <Col md={2}>
                        <Row>
                            &nbsp;
                        </Row>
                        <Row>
                            &nbsp;
                        </Row>
                        <Row>
                            <Col md={12}>
                                <CastVoteToolbar
                                    certificationKey={this.props.selectedId}
                                    comments={this.state.form.comments}
                                    onSave={this.handleCastVote}
                                    voteStatus={this.state.form.voteStatus}
                                    disableVoting={this.state.form.disableVoting}
                                    fastVote={false} />
                            </Col>
                        </Row>
                    </Col>
                </React.Fragment>
            );
        }
        else {
            return (
                <Col md={1}>
                </Col>
            );
        }
    }

    renderForm() {
        let me = this;
        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={12}>
                                <h3 style={{ marginTop: "0px", position: "relative" }}>
                                    <AdminAppIdHeader appId={this.state.form.certificationId} daysOpen={this.props.setupProps.daysOpen} certificationType={this.state.form.certificationType} certificationStatus={this.state.form.certificationStatus} />
                                </h3>
                                <hr />
                                <h3 style={{ marginTop: "0px" }}>
                                    Committee Review
                                    {ReviewHelpers.renderAdminStepToolbar(ReviewType.COMMITTEE_REVIEW.code, QueueType.COMMITTEE_REVIEW.code, this.state.form, this.props, this._ast )}
                                </h3>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <hr />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    {me.renderStatusCheckboxes()}
                    {me.renderCastVote()}
                </Row>
                <Row>
                    <Col md={12}>
                        <h3>
                            Committee Voting Log - <small>History of all Votes related to this Application</small>
                        </h3>
                        <hr />
                    </Col>
                </Row>
                <Row>
                    <Col sm={12}>
                        <VotesGrid
                            votes={this.state.form.votes} />
                    </Col>
                </Row>
                <Row>
                    <CommentsGrid
                        ref={(c) => { this._commentsGrid = c }}
                        comments={this.state.form.comments}
                        documents={this.state.form.reviewDocuments}
                        certificationKey={this.props.selectedId}
                        reviewTypeCode={ReviewType.COMMITTEE_REVIEW.code}
                        queueTypeCode={QueueType.COMMITTEE_REVIEW.code}
                        enableExport={true}
                        entityId={this.state.form.entityId}
                        readonly={!this.state.privileges.edit || !this.state.enabled || !this.state.form.queueAssigned}
                        onSave={this.handleCommentsGrid}
                        onCommentChange={this.handleCommentChange}
                        showAddButton={true} />
                </Row>
            </React.Fragment>
        )
    }
}

export default CommReview;



// WEBPACK FOOTER //
// ./src/areas/admin/certification/commReview/CommReview.js